import { useContext } from 'react';
import { BCTContext } from '../context/BCTContextDefinition';
import { AuthContext } from '../context/AuthContextDefinition';
import type { AuthContextType } from '../context/AuthContextDefinition';

export const useBCT = () => {
    const context = useContext(BCTContext);
    if (context === undefined) {
        throw new Error('useBCT must be used within a BCTProvider');
    }
    return context;
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};